import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ForgotPassword from "views/auth/forgetPassword";
import VerifyOTP from "views/auth/otpVerfication";
import ResetPassword from "views/auth/resetPassword";
import ViewUser from "views/admin/Users/ViewUser/ViewStore";
import { initializeInterceptors } from "config/axios";
import { useAxiosInterceptors } from "config/axios";
import ContactUsPublic from "views/ContactUsPublic";
import PrivacyPolicyPublic from "views/PrivacyPolicyPublic";
const App = () => {
  function isTokenExists() {
    const userDataString = localStorage.getItem("userData");
    const userData = JSON.parse(userDataString);
    const authToken = userData?.token;
    console.log("authToken", authToken);
    return authToken !== null && authToken !== undefined;
  }
  // ProtectedRoute component to handle redirectionwwwss
  function ProtectedRoute({ element }) {
    return isTokenExists() ? element : <Navigate to="/auth/sign-in" />;
  }
  useAxiosInterceptors();

  // useEffect(() => {
  //   initializeInterceptors();
  // }, []);

  return (
    
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="/contact-us" element={<ContactUsPublic />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPublic />} />

      <Route
        path="admin/*"
        element={<ProtectedRoute element={<AdminLayout />} />}
      />
      {/* <Route path="admin/*" element={<AdminLayout />} /> */}
      {/* <Route path="users/:userId" element={<ViewUser />} /> */}
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default App;
